import { CalendarClock } from "lucide-react";

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export function TodayShift({ shifts }) {
  const mine = shifts.find((s) => s.data === today());
  const orario = (mine?.orario || "").trim();
  return (
    <div className="grid sm:grid-cols-2 gap-3 mb-10 fade-up" data-testid="today-shift">
      <div className="panel !p-5 flex items-center gap-4">
        <span className="w-11 h-11 rounded-xl bg-[var(--navy)] flex items-center justify-center shrink-0"><CalendarClock className="w-5 h-5 text-white" /></span>
        <div><p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Il tuo turno di oggi</p>
          <p className="font-display text-xl font-bold text-[var(--navy)]" data-testid="today-shift-orario">{orario || "Nessun turno"}</p></div>
      </div>
    </div>
  );
}
